import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import apiFetch from 'utils/apiFetch';
import Modal from '@material-ui/core/Modal';
import {
  STATUS_INIT, STATUS_SAVED, STATUS_INVITATIONS_SENT, STATUS_NO_INVITATIONS_SENT, STATUS_SAVING,
} from 'constants/status';
import { ROUTE_THINK } from 'constants/urls';
import AutocompleteInput from 'components/AutocompleteInput';
import FilterChat from 'components/Chats/components/FilterChat';
import unloadedImage from 'assets/images/icons/unloadedImage.svg';
import deleteIcon from 'assets/images/think/deleteIcon.svg';
import Lock from 'assets/images/unlock.svg';
import CallIcon from 'assets/images/icons/call_black.svg';
import ArrowBack from 'assets/images/ArrowBack.svg';
import Switch from '@material-ui/core/Switch';
import AvatarNew from 'components/AvatarNew';
import Avatar from 'components/Avatar';
import {
  FormWrapper, Image, InputName, InputDescription, BtnSubmit, ErrorLayer,
  MyNetworkWrapper, IconTitle, MsgSuccess, TagsWrapper, TagLabel, InvitePeopleView, TimeLife, TagContainer, PrivateTable, CreatedIn, CongratulationsModal,
  InvitePeople, MyNetworkGrid, PeopleSelected, InviteButton, UserAround, CircleImage, UserWrapper, TitleBack,
} from './styles';

class CreationThinkSeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      description: '',
      image: '',
      uploadingImage: false,
      error: '',
      status: STATUS_INIT,
      table: null,
      tags: [],
      isNext: false,
      isLoading: false,
      day: 7,
      hour: 0,
      minute: 0,
      seconds: 0,
      enableSwitch: false,
      filter: '',
      call: props.callId,
      // filter: '',
      peopleSelected: [],
      // speedDate: new Date(),
      // speedHour: 0,
      // timeLife: 0,
    };
  }

  getColor = () => {
    const { actualContext: context, app } = this.props;

    let color = app.color1;

    if (context && context.color) {
      color = typeof context.color === 'string' ? context.color : context.color.color;
    }

    return color;
  }

  setTimeLife = (event) => {
    let value = event.currentTarget.value ? parseInt(event.currentTarget.value, 10) : 0;

    if (Number.isNaN(value) || value < 0) {
      value = 0;
    }

    const attrTime = event.currentTarget.getAttribute('attr-time');
    this.setState({ [attrTime]: value });
  }

  // setSpeedDate = (event) => {
  //   this.setState({ speedDate: event.currentTarget.value });
  // }

  // setSpeedHour = (event) => {
  //   this.setState({ speedHour: parseInt(event.currentTarget.value, 10) });
  // }

  handleFileUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      const file = event.target.files[0];
      const { name } = file;

      const reader = new FileReader();
      reader.onloadend = () => {
        this.uploadImage(reader.result, name);
      };
      reader.readAsDataURL(file);
    }
  }

  handleUnselectPeople = (event) => {
    const { peopleSelected } = this.state;

    const id = parseInt(event.currentTarget.getAttribute('user-data_id'), 10);

    const index = peopleSelected.findIndex(user => user.id === id);

    if (index >= 0) {
      peopleSelected.splice(index, 1);
      this.setState({ peopleSelected });
    }
  }

  handleGoBack = () => {
    const { isNext } = this.state;
    const { history } = this.props;

    if (!isNext) {
      history.goBack();
    } else {
      this.setState({ isNext: false });
    }
  }

  uploadImage = (data, name) => {
    const { literals } = this.props;
    const params = {
      data,
      name,
    };

    this.setState({ uploadingImage: true });
    apiFetch('POST', { endPoint: 'upload-file' }, params)
      .then((response) => {
        const { error } = this.state;
        let newError = error;
        if (error === literals.errorUploadingImage) {
          newError = null;
        }
        this.setState({ image: response.url, uploadingImage: false, error: newError });
      })
      .catch(() => {
        const { error } = this.state;
        let newError = error;
        if (error === literals.errorUploadingImage) {
          newError = null;
        }
        this.setState({ image: '', uploadingImage: false, error: newError });
      });
  }

  handleChangeName = (event) => {
    const { value } = event.target;

    this.setState({ name: value });
  }

  handleSelectUser = (event) => {
    const { peopleSelected } = this.state;


    const user = {
      id: parseInt(event.currentTarget.getAttribute('data-user_id'), 10),
      name: event.currentTarget.getAttribute('name'),
      avatar: event.currentTarget.getAttribute('avatar'),
    };

    const index = peopleSelected.findIndex(elem => elem.id === user.id);
    if (index >= 0) {
      peopleSelected.splice(index, 1);
    } else {
      peopleSelected.push(user);
    }

    this.setState({ peopleSelected });
  }

  handleChangeDescription = (event) => {
    const { value } = event.target;

    this.setState({ description: value });
  }

  continue = () => {
    const {
      status, name, uploadingImage,
    } = this.state;
    const { literals } = this.props;
    if (status === STATUS_INIT) {
      if (!name) {
        this.setState({ error: literals.errorName });
        return false;
      }

      if (uploadingImage) {
        this.setState({ error: literals.errorUploadingImage });
        return false;
      }

      this.setState({ isNext: true });
    }
    return true;
  }

  submit = () => {
    const { joinThemeTable, getChats } = this.props;
    const {
      name, description, image, uploadingImage, status, tags, peopleSelected, call, enableSwitch,
      day, hour, minute, seconds,
    } = this.state;

    if (status === STATUS_INIT) {
      const { literals, actualContext } = this.props;

      if (!name) {
        this.setState({ error: literals.errorName });
        return false;
      }

      if (uploadingImage) {
        this.setState({ error: literals.errorUploadingImage });
        return false;
      }

      let elementType = '';
      let elementId = 0;

      if (actualContext) {
        elementType = actualContext.elementType ? actualContext.elementType : 'narrative';

        if (actualContext.id) {
          elementId = actualContext.id;
        }

        if (actualContext.elementId) {
          elementId = actualContext.elementId;
        }
      }

      let params = {
        id: null,
        name,
        description,
        image,
        tags: tags.join('%_%'),
        element_type: elementType,
        element_id: elementId,
        private: +enableSwitch,
        call,
        timelimit: moment().unix() + (day * 86400) + (hour * 1440) + (minute * 60) + seconds,
        type: 21283817,
      };


      this.setState({ status: STATUS_INVITATIONS_SENT });


      this.setState({ error: false, status: STATUS_SAVING });
      this.setState({ isLoading: true });
      apiFetch('POST', { endPoint: 'think-seed' }, params)
        .then((table) => {
          params = {
            id: table.id,
            users: _.map(peopleSelected, user => user.id).join(','),
          };
          joinThemeTable(table);
          getChats();
          apiFetch('POST', { endPoint: `/think-seed/${table.id}/invitations` }, params).then(() => {
            this.setState({ status: STATUS_INVITATIONS_SENT, table });
            this.setState({ isLoading: false });
          });
        })
        .catch(() => {
          this.setState({ error: literals.errorSaving, status: STATUS_INIT });
        });
      return true;
    }

    return true;
  }

  printGridUsers = () => {
    const { filter, peopleSelected } = this.state;
    const { userConnections, literals } = this.props;
    let usersFiltered = [];
    let users = [];

    if (!userConnections || !userConnections.length) {
      return null;
    }

    if (userConnections) {
      if (filter !== '') {
        const lowerFilter = filter.toLowerCase();
        usersFiltered = _.filter(userConnections, (user) => {
          const completeName = (`${user.firstname} ${user.lastname}`).toLowerCase();

          if (completeName.includes(lowerFilter)) {
            return true;
          }
          return false;
        });
      } else {
        usersFiltered = userConnections;
      }

      users = usersFiltered.map((user) => {
        let isSelected = false;
        const completeName = `${user.firstname} ${user.lastname}`;
        if (peopleSelected.findIndex(elem => elem.id === user.id) >= 0) {
          isSelected = true;
        }

        return (
          <div key={user.id} data-user_id={user.id} avatar={user.avatar} name={completeName} onClick={this.handleSelectUser}>
            <AvatarNew avatar={user.avatar} firstname={completeName} id={user.id} invite isSelected={isSelected} />
          </div>
        );
      });
    }

    return (
      <MyNetworkWrapper>
        <div className='title_network'>{literals.myNetwork}</div>
        <MyNetworkGrid>
          {users}
        </MyNetworkGrid>
      </MyNetworkWrapper>
    );
  }

  printImage = () => {
    const { image, uploadingImage } = this.state;
    const { literals } = this.props;
    const button = (
      <div className='upload'>
        <img src={unloadedImage} alt='upload' style={{ minHeight: '5rem' }} />
        {literals.pressToUploadImage}
      </div>);
    const color = this.getColor();
    return (
      <Image
        image={image}
        htmlFor='document_file'
        color={color}
      >
        {
          !image && !uploadingImage && button
        }
        {
          !image && uploadingImage && literals.uploading
        }
        {image && (
          <img className='uploaded' src={image} alt='' />
        )}
      </Image>
    );
  }

  printRelated = () => {
    const { tags } = this.state;

    if (tags.length > 0) {
      return <React.Fragment />;
    }

    return <React.Fragment />;
  }

  handleChangeEnabled = () => {
    const { enableSwitch } = this.state;
    this.setState({ enableSwitch: !enableSwitch });
  }

  cancelInvitations = () => {
    this.setState({ error: '', status: STATUS_NO_INVITATIONS_SENT });
  }

  printTable = (noTitle) => {
    const { image, name, peopleSelected } = this.state;
    const { literals } = this.props;

    let usersAround = [];

    if (peopleSelected.length) {
      let left = '';
      let top = '';
      usersAround = peopleSelected.map((user, index) => {
        if (index === 0) {
          left = '-1rem';
          top = '2rem';
        }

        if (index === 1) {
          left = '16rem';
          top = '2rem';
        }

        if (index === 2) {
          top = '13rem';
          left = '-1rem';
        }

        if (index === 3) {
          left = '16rem';
          top = '13rem';
        }

        if (index === 4) {
          left = '7rem';
          top = '-2rem';
        }

        if (index === 5) {
          left = '7rem';
          top = '17rem';
        }

        if (index > 5) {
          return <React.Fragment />;
        }

        return (
          <UserAround style={{ left, top }} key={user.id}>
            <Avatar avatar={user.avatar} size={40} firstname={user.name} />
          </UserAround>
        );
      });
    }

    return (
      <InvitePeople>
        {!noTitle ? (
          <div className='title_invite'>
            {literals.invitePeopleFromMyNetwork}
          </div>
        ) : null}
        <div className='circle_view'>
          <CircleImage img={image}>
            <div className='title_name'>
              <div>
                {name}
              </div>
            </div>
            {usersAround}
          </CircleImage>
        </div>
      </InvitePeople>
    );
  }

  printSelectedOnCircle = () => {
    const { peopleSelected } = this.state;
    return <React.Fragment />;
  }

  printSelected = () => {
    const { peopleSelected } = this.state;
    const { literals } = this.props;

    const count = peopleSelected.length;

    if (count > 0) {
      const print = peopleSelected.map((user) => {
        return (
          <UserWrapper key={user.id} className='user_wrapper'>
            <div>
              <Avatar
                key={user.id}
                id={user.id}
                avatar={user.avatar}
                firstname={user.name}
                size={52}
              />
              <div className='userContent'>
                <div className='name'>
                  {`${user.name}`}
                </div>
              </div>
            </div>
            <button user-data_id={user.id} onClick={this.handleUnselectPeople}>
              <img src={deleteIcon} alt='' />
            </button>
          </UserWrapper>
        );
      });

      const title = `${count} ${literals.peopleSelected}`;

      return (
        <PeopleSelected>
          <div className='title'>
            {title}
          </div>
          {print}
        </PeopleSelected>
      );
    }

    return <React.Fragment />;
  }

  printInvitationsSent = () => {
    const { literals, setCanDrag, fromChats } = this.props;

    let msg = '';

    if (fromChats) {
      msg = literals.invitationsHasBeenSent2;
    } else {
      setCanDrag(true);
      msg = literals.invitationsHasBeenSent;
    }

    return (
      <FormWrapper>
        <MsgSuccess>{msg}</MsgSuccess>
      </FormWrapper>
    );
  }

  printSearcher = () => {
    return (
      <FilterChat doFilter={this.filterUsers} />
    );
  }

  handleCallChange = (event) => {
    const call = parseInt(event.currentTarget.value, 10);

    this.setState({ call });
  }

  printCreatedIn = () => {
    const { literals, narratives } = this.props;
    const { call } = this.state;
    const content = [];

    if (narratives.length > 0) {
      narratives.forEach((narrative) => {
        if (narrative.section.name === 'Call for impact') {
          content.push(<option value={narrative.id} key={narrative.id}>{narrative.name}</option>);
        }
      });

      return (
        <CreatedIn>
          <img src={CallIcon} alt='' />
          <select onChange={this.handleCallChange} value={call}>
            <option value={0}>{literals.createdIn}</option>
            {content}
          </select>
        </CreatedIn>
      );
    }

    return <React.Fragment />;
  }

  printNoInvitationsSent = () => {
    
    return <Redirect to={ROUTE_THINK} />;
  }

  handleTag = (tag) => {
    const { tags } = this.state;
    const newTags = [...tags];

    newTags.push(tag);
    this.setState({ tags: newTags });
  }

  removeTag = (event) => {
    const { tags } = this.state;
    const tagId = parseInt(event.currentTarget.getAttribute('data-id'), 10);

    const index = tags.findIndex(tag => tag.id === tagId);

    if (index < 0) {
      return 0;
    }

    const newTags = [...tags];
    newTags.splice(index, 1);
    this.setState({ tags: newTags });
    return 0;
  }

  filterUsers = (value) => {
    this.setState({ filter: value });
  }

  printForm = () => {
    const {
      literals, data,
    } = this.props;
    const {
      name, description, error, isNext, enableSwitch, peopleSelected, isLoading,
    } = this.state;

    const color = this.getColor();

    const darkerColor = color;

    return (
      <React.Fragment>
        {!isNext && (
          <FormWrapper>
            <div className='title_card_wrapper'>
              {data.more_info && data.more_info.icon_title && (
                <IconTitle className='title_card_icon' icon={data.more_info.icon_title} />
              )}
              {}
            </div>
            {
              this.printImage()
            }
            <input
              type='file'
              id='document_file'
              name='document_file'
              style={{ display: 'none' }}
              onChange={this.handleFileUpload}
              accept='image/png, image/jpeg'
            />
            <InputName
              value={name}
              placeholder={literals.titleName}
              onChange={this.handleChangeName}
            />
            <InputDescription
              value={description}
              placeholder={literals.description}
              onChange={this.handleChangeDescription}
            />
            <TagsWrapper>
              <AutocompleteInput
                canCreateNew
                type='tag'
                placeholder={literals.tags}
                selectedOptions={[]}
                onSelectOption={this.handleTag}
                onCreateOption={this.handleTag}
              />
            </TagsWrapper>
            {this.printTags()}
            {this.printCreatedIn()}
            <TimeLife>
              <div>
                {literals.timeLife}
              </div>
              <div className='time_life'>
                <input type='text' maxLength='2' attr-time='day' value={this.state.day} onChange={this.setTimeLife} placeholder='00' />
                {' days : '}
                <input type='text' maxLength='2' attr-time='hour' value={this.state.hour} onChange={this.setTimeLife} placeholder='00' />
                {' hours : '}
                <input type='text' maxLength='2' attr-time='minute' value={this.state.minute} onChange={this.setTimeLife} placeholder='00' />
                {' min : '}
                <input type='text' maxLength='2' attr-time='seconds' value={this.state.seconds} onChange={this.setTimeLife} placeholder='00' />
                {' sec'}
              </div>
            </TimeLife>
            {}
            <PrivateTable>
              <div>
                {literals.privateTable}
              </div>
              <div>
                <img src={Lock} alt='' />
                <Switch
                  checked={enableSwitch}
                  size='small'
                  onChange={this.handleChangeEnabled}
                  name='check_enabled'
                  color='primary'
                />
                {literals.onlyInvited}
              </div>
            </PrivateTable>
            {
              this.printRelated()
            }

          </FormWrapper>
        )}
        {isNext && (
          <React.Fragment>
            <InvitePeopleView>
              <div className='table_view'>
                {this.printTable()}
              </div>
              <div className='people_selected'>
                {this.printSelected()}
              </div>
            </InvitePeopleView>
            {this.printGridUsers()}

          </React.Fragment>
        )}
        { peopleSelected.length === 0 && !isLoading
        && (
          <BtnSubmit type='button' onClick={isNext ? this.submit : this.continue} status={name} color={color || color.color} darkerColor={darkerColor}>
            {literals.next}
          </BtnSubmit>
        )}
        { peopleSelected.length === 0 && isLoading
        && (
          <BtnSubmit type='button' status={name} color={color || color.color} darkerColor={darkerColor}>
            {literals.loading}
          </BtnSubmit>
        )}
        {
          error && (
            <ErrorLayer>{error}</ErrorLayer>
          )
        }
      </React.Fragment>
    );
  }

  printTags = () => {
    const { tags } = this.state;

    const tagList = _.map(tags, (tag, index) => (<TagLabel key={index} data-id={tag.id} onClick={this.removeTag}>{tag.name}</TagLabel>));

    if (tags.length > 0) {
      return (
        <TagContainer>
          {tagList}
        </TagContainer>
      );
    }

    return <React.Fragment />;
  }

  printGoBack = () => {
    const { literals } = this.props;
    return (
      <TitleBack>
        <div className='title_create'>
          <img src={ArrowBack} alt='' onClick={this.handleGoBack} />
          <div>{literals.createNewTable}</div>
        </div>
      </TitleBack>
    );
  }


  printInviteButton = () => {
    const { literals } = this.props;
    const { peopleSelected, isLoading } = this.state;
    if (peopleSelected.length === 0) {
      return null;
    }
    if (isLoading) {
      return (
        <InviteButton>
          <button className='primary'>{literals.loading}</button>
        </InviteButton>
      );
    }
    return (
      <InviteButton>
        <button className='primary' onClick={this.submit}>{literals.invite}</button>
      </InviteButton>
    );
  }

  goToThink = () => {
    const { history } = this.props;
    history.push(ROUTE_THINK);
  }

  goToTable = () => {
    const { table } = this.state;
    const { history } = this.props;

    history.push(`/theme-table/${table.id}`);
  }

  goToTableChat = () => {
    const { table } = this.state;
    const { history } = this.props;

    history.push(`/theme-table/${table.id}/chat`);
  }

  printCongratulations = () => {
    const { literals } = this.props;
    return (
      <Modal
        open
        onClose={this.goToThink}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        style={{ zIndex: 400 }}
      >
        <CongratulationsModal>
          {this.printTable(true)}
          <div className='message_success'>{literals.youHaveCreateTheTable}</div>
          <div className='buttons'>
            <button className='primary btn-sm' onClick={this.goToTable}>{literals.addContent}</button>
            <button className='welcome' onClick={this.goToTableChat}>{literals.welcome}</button>
          </div>
        </CongratulationsModal>
      </Modal>
    );
  }


  render() {
    const { status, isNext } = this.state;
    return (
      <React.Fragment>
        {(status === STATUS_INVITATIONS_SENT || status === STATUS_SAVED || status === STATUS_NO_INVITATIONS_SENT)
          ? this.printCongratulations()
          : null}
        {this.printGoBack()}
        {this.printForm()}
        {isNext && this.printInviteButton()}
      </React.Fragment>
    );
  }
}

CreationThinkSeed.propTypes = {
  literals: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actualContext: PropTypes.object,
  setCanDrag: PropTypes.func.isRequired,
  fromChats: PropTypes.bool,
  app: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  narratives: PropTypes.array.isRequired,
  userConnections: PropTypes.array.isRequired,
  getChats: PropTypes.func.isRequired,
  joinThemeTable: PropTypes.func.isRequired,
  callId: PropTypes.number,
};

CreationThinkSeed.defaultProps = {
  fromChats: false,
  actualContext: null,
  callId: null,
};

export default CreationThinkSeed;



// WEBPACK FOOTER //
// ./src/components/CreationThinkSeed/components/CreationThinkSeed.jsx